import React, { Component } from "react";
import { Tabs, Form, Spin } from "antd";
import "./Calculation.scss";
import { connect } from "react-redux";
import CalculationSummary from "./CalculationSummary";
import { GetFinancingRequestDetails, GetFinancingRequestAccountingHistory } from "../../network/customer.network";
import { GetFinancingAgencyEmployeesByAgencyId } from "../../network/profile.network";
import { setUserRequest } from "../../redux/user/user.action";
import CalcStatuse from "./CalcStatuse";

const { TabPane } = Tabs;

class Calculation extends Component {

  formUserRef = React.createRef();
  formEditCalcRef = React.createRef(); 
  state = {
    accountingList: [],
    accountingListRealestate: [],
    RequestAccountingHistory: [],
    agencyEmployees: [],
    isModalVisible: false,
    showTimeline: false,
    calcSelect: false,
    calcSelectRealestate: false,
    confirmLoading: false,
    isCalcEdit: false,
    isPersonalFinancing: false,
    isRealestateFinancing: false,
    showEmpWarning: false,
    selectedAccountInfo: null,
    selectedAccountInfoRealestate: null,
    selectedAccountId: null,
    StatusLogs: null,
    selectedAccountIdRealestate: null,
    FinancingAgencyEmployeeId: null,
    FinancingRequestTypeId: "1",
  };

  componentDidMount() {
    this.handelGetFinancingRequestDetails();
  }
  
  handelGetFinancingRequestAccountingHistory = () => {
    const { orderId } = this.props;
    const { FinancingRequestTypeId } = this.state;
    this.setState({tabLoading : true})
    GetFinancingRequestAccountingHistory(
      orderId,
      FinancingRequestTypeId, 
      (res) => {
        this.setState({ RequestAccountingHistory: res.data.model, tabLoading : false });
      },
      (err) => {
        //console.log(err);
        this.setState({tabLoading : false})
      }
    );
  };

  handelGetFinancingRequestDetails = () => { 
    const {userRequest, orderId} = this.props;
    this.setState({tableLoading : true})
    GetFinancingRequestDetails( orderId ? orderId : userRequest?.Id , (res) => {
      this.setState({
        FinancingRequestDetails : res.data.model, 
        StatusLogs : res.data.model?.FinancingRequestGeneralStatusLogs,
        tableLoading : false, 
        isRealestateFinancing: res.data.model.RealestateFinancingRequest, 
        isPersonalFinancing : res.data.model.PersonalFinancingRequest,
      });
      if(res.data.model.PersonalFinancingRequest?.FinancingRequestAccounting){ 
        this.setState({calcSelect : true, selectedAccountId : res.data.model?.PersonalFinancingRequest?.FinancingRequestAccounting }) 
      }
      if(res.data.model.RealestateFinancingRequest?.FinancingRequestAccounting){
        this.setState({calcSelectRealestate : true, selectedAccountIdRealestate : res.data.model?.RealestateFinancingRequest?.FinancingRequestAccounting})
      }
      this.props.dispatch(setUserRequest(res.data.model));

      setTimeout(() => {
          this.setState({FinancingRequestTypeId : this.props.userRequest.RealestateFinancingRequest ? "2" : "1"})
          setTimeout(() => {
            if (this.props.orderId) {
              this.handelGetFinancingRequestAccountingHistory();
            }else{
              this.setState({tabLoading : false})
            }
          }, 300);
      }, 500)
    }, (err) => { 
      this.setState({tableLoading : false})
    })
  }
  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys, isModalVisible: true });
  };

  onSelectChangeRealestate = (selectedRowKeysRealestate) => {
    this.setState({ selectedRowKeysRealestate, isModalVisible: true });
  };

fetchFinancingAgencyEmployee = () => {
  const {selectedAccountInfo, selectedAccountInfoRealestate, FinancingRequestTypeId} = this.state;
  GetFinancingAgencyEmployeesByAgencyId(FinancingRequestTypeId === "1" ?
   selectedAccountInfo?.FinancingAgency?.Id : selectedAccountInfoRealestate?.FinancingAgency?.Id, (res) => {
    this.setState({agencyEmployees : res.data.model, tableLoading : false});
}, (err) => {
    this.setState({tableLoading : false});
})
}

  render() {
    const {
      selectedRowKeys,
      selectedRowKeysRealestate,
      calcSelect,
      calcSelectRealestate,
      StatusLogs,
      FinancingRequestTypeId,
      btnLoading,
      accountingList,
      selectedAccountInfo,
      selectedAccountInfoRealestate,
      selectedAccountId,
      selectedAccountIdRealestate,
      isRealestateFinancing,
      isPersonalFinancing,
      RequestAccountingHistory,
      tabLoading,
    } = this.state;
    const { userRequest } = this.props;

    return (
      <div className="finance-tab-content calculation-page">
        <h2 className="tab-title">الحسبة</h2>

        <CalculationSummary userRequest={userRequest} />

        <Form id="orderForm3"
          onFinish={this.props.submitForm}
        >
        </Form>

        <Spin spinning={tabLoading}>

        <div className="calc-tabs">
          <Form
            className="form-add-content funder-form-holder"
            layout="vertical"
            name="nest-messages"
            id="orderForm3"
            ref={this.formUserRef}
            onFinish={this.onFinish}
          > 
          <Tabs
            activeKey={FinancingRequestTypeId}
            onChange={(val) => {
              console.log(val); 
              this.setState({ FinancingRequestTypeId: val });
            }}
          >
            {isPersonalFinancing &&
                        <TabPane tab="تمويل شخصي" key="1">
                          {calcSelect && 
                            <div className={`calc-summary-holder calc-summary-send-holder ${StatusLogs.some(ele=> ele.FinancingRequestGeneralStatusId === 546) && " d-none"}`}>
                            <div className="summary-col">
                              <div className="summary-info-row">
                                <p>جهه التمويل</p>
                                <h5>{RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.FinancingAgency?.NameLT ||
                              selectedAccountId?.FinancingAgency?.NameLT}</h5>
                              </div>
                              <div className="summary-info-row">
                                <p>التمويل</p>
                                <h5>
                                {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.FinancingAmout} <span>ر.س</span>
                                </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>نسبة الإستقطاع</p>
                                <h5>٪{RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.CutOfRatio}</h5>
                              </div>
                              <div className="summary-info-row">
                                <p>نوع التمويل</p>
                                <h5>شخصي</h5>
                              </div>
                            </div>
                            <div className="summary-col">
                              <div className="summary-info-row">
                                <p>القسط</p>
                                <h5>
                                {Math.round(RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.MonthlyInstallment*100)/100} <span>ر.س</span>
                                </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>مدة السداد بالاشهر</p>
                                <h5>
                                {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.MonthsCount} <span>شهر</span>
                                </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>قسط الدعم</p>
                                <h5>
                                {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.SupportInstallment} <span>ر.س</span>
                                </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>الربح</p>
                                <h5>%{RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.AccountingRatioValue}</h5>
                              </div>
                              <div className="summary-info-roww">
                                <h6 style={{ color: '#cc3524' }}>
                                  هذه الحسبة بناء على الحد الإئتماني والمبلغ النهائي يكون بعد تقييم العقار 
                                </h6>
                              </div>                             
                            </div>
                          </div>
                          }
                        </TabPane>
            }
            {isRealestateFinancing &&
                        <TabPane tab="تمويل عقاري" key="2">
                          {calcSelectRealestate && 
                            <div className={`calc-summary-holder calc-summary-send-holder ${StatusLogs.some(ele=> ele.FinancingRequestGeneralStatusId === 546) && " d-none"}`}>
                          
                              <div className="summary-col">
                              <div className="summary-info-row">
                                <p>جهه التمويل</p>
                                <h5>
                                {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.FinancingAgency
                              ?.NameLT ||
                              selectedAccountIdRealestate?.FinancingAgency
                                ?.NameLT}
                                  </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>التمويل</p>
                                <h5>
                                {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.FinancingAmout} <span>ر.س</span>
                                </h5>
                              </div>
                              <div className="summary-info-row">
                                <p>نسبة الإستقطاع</p>
                                <h5>٪{RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.CutOfRatio}</h5>
                              </div>
                              <div className="summary-info-row">
                                <p>نوع التمويل</p>
                                <h5>عقاري</h5>
                              </div>
                              
                              </div>

                              <div className="summary-col unique">
                                <div className="summary-info-row">
                                  <p>القسط</p>
                                  <h5>
                                  {Math.round(RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.MonthlyInstallment*100)/100} <span>ر.س</span>
                                  </h5>
                                </div>
                                <div className="summary-info-row">
                                  <p>مدة السداد بالاشهر</p>
                                  <h5>
                                  {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.MonthsCount} <span>شهر</span>
                                  </h5>
                                </div> 
                                <div className="summary-info-row">
                                  <p>قسط الدعم</p>
                                  <h5>
                                  {RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.SupportInstallment} <span>ر.س</span>
                                  </h5>
                                </div>
                                <div className="summary-info-row">
                                  <p>الربح</p>
                                  <h5>%{RequestAccountingHistory?.[0]?.FinancingRequestAccountingObject?.AccountingRatioValue}</h5> 
                                </div>
                                
                              </div> 
                              <div className="summary-info-roww">
                                <h6 style={{ color: '#cc3524' }}>
                                  هذه الحسبة بناء على الحد الإئتماني والمبلغ النهائي يكون بعد تقييم العقار 
                                </h6>
                              </div>                             
                            
                            </div>
                      
                          }
                      </TabPane>
            }
          </Tabs>
          </Form>
 
                    {StatusLogs && <CalcStatuse 
                    FinancingRequestTypeId={FinancingRequestTypeId} 
                    selectedAccountId={selectedAccountId || selectedAccountIdRealestate} 
                    StatusLogs={StatusLogs} />} 

        </div>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userRequest: state.user.userRequest, 
  Customer: state.user?.currentUser, 
});
export default connect(mapStateToProps)(Calculation); 